export default {
  defaultDisplayDateFormat: {
    en: 'DD.MM.YYYY',
    fi: 'pp.kk.vvvv',
    sv: 'dd.mm.åååå'
  },
  instructions: {
    en: {
      helpText: _ref => {
        let {
          dateFormat
        } = _ref;
        return "Use the date format " + dateFormat;
      }
    },
    fi: {
      helpText: _ref2 => {
        let {
          dateFormat
        } = _ref2;
        return "K\xE4yt\xE4 p\xE4iv\xE4m\xE4\xE4r\xE4muotoa " + dateFormat;
      }
    },
    sv: {
      helpText: _ref3 => {
        let {
          dateFormat
        } = _ref3;
        return "Anv\xE4nd datumformatet " + dateFormat;
      }
    }
  },
  errorMessages: {
    pastDatesNotAllowed: {
      en: 'Check the date. The date may occur today at the earliest.',
      fi: 'Tarkista päivämäärä. Päivämäärä voi olla aikaisintaan tänään.',
      sv: 'Kontrollera datumet. Datumet kan vara tidigast i dag.'
    },
    weekendsNotAllowed: {
      en: 'Check the date. The date may not be Saturday or Sunday.',
      fi: 'Tarkista päivämäärä. Päivämäärä ei voi olla lauantai tai sunnuntai.',
      sv: 'Kontrollera datumet. Datumet kan inte vara en lördag eller en söndag.'
    },
    blocked: {
      en: 'Check the date. Date you entered is not permitted.',
      fi: 'Tarkista päivämäärä. Kirjoittamasi päivämäärä ei ole sallittu.',
      sv: 'Kontrollera datumet. Datumet du fyllt i är inte tillåtet.'
    },
    blockedByMinDate: {
      en: _ref4 => {
        let {
          dateForErrMsg
        } = _ref4;
        return "Check the date. The date may be no earlier than on " + dateForErrMsg + ".";
      },
      fi: _ref5 => {
        let {
          dateForErrMsg
        } = _ref5;
        return "Tarkista p\xE4iv\xE4m\xE4\xE4r\xE4. P\xE4iv\xE4m\xE4\xE4r\xE4 voi olla aikaisintaan " + dateForErrMsg + ".";
      },
      sv: _ref6 => {
        let {
          dateForErrMsg
        } = _ref6;
        return "Kontrollera datumet. Datumet kan vara tidigast " + dateForErrMsg + ".";
      }
    },
    blockedByMaxDate: {
      en: _ref7 => {
        let {
          dateForErrMsg
        } = _ref7;
        return "Check the date. The latest permitted date is " + dateForErrMsg + ".";
      },
      fi: _ref8 => {
        let {
          dateForErrMsg
        } = _ref8;
        return "Tarkista p\xE4iv\xE4m\xE4\xE4r\xE4. My\xF6h\xE4isin sallittu p\xE4iv\xE4m\xE4\xE4r\xE4 on " + dateForErrMsg + ".";
      },
      sv: _ref9 => {
        let {
          dateForErrMsg
        } = _ref9;
        return "Kontrollera datumet. Det senaste till\xE5tna datumet \xE4r " + dateForErrMsg + ".";
      }
    },
    notDate: {
      en: 'Information you entered is not a date. Check the information.',
      fi: 'Kirjoittamasi tieto ei ole päivämäärä. Tarkista tieto.',
      sv: 'Uppgiften du fyllt i är inte ett datum. Kontrollera uppgiften.'
    },
    yearNotFullLength: {
      en: 'Enter the year in YYYY format.',
      fi: 'Kirjoita vuosiluku muodossa vvvv.',
      sv: 'Ange årtalet i formatet åååå.'
    }
  }
};